<span>
  <i class="bi bi-clock-history ag-pr-5"></i>
  <span>{{ tempoDecorrido }}</span>
</span>
